import { API_PATHS } from "../constants/api-paths";
import { COMMON_SSO_MOBILE } from "../constants/sso";
import { createCacheAsync } from "@repo/shared-utils/cache";
import { decryptLocalStorageMobileNo } from "@repo/shared-utils/crypto";
import { encryptedRequest } from "../core/api.client";

export interface IIconResponseData {
  data: ISection[];
}

export interface ISection {
  section: string;
  sectionValue: string;
  priority: number;
  isUat: boolean;
  isProd: boolean;
  isApp: boolean;
  isWeb: boolean;
  sectionData: unknown;
}

export const iconApiCall = async (): Promise<IIconResponseData> => {
  const localStorageMobileNo = localStorage.getItem(COMMON_SSO_MOBILE);
  const mobileNo = await decryptLocalStorageMobileNo(localStorageMobileNo || "");
  try {
    const response = await encryptedRequest<IIconResponseData>({
      method: "POST",
      url: `${API_PATHS.pimcoreIcons}`,
      data: {
        mobileNo: mobileNo ?? "",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching icon data:", error);
    return {} as IIconResponseData;
  }
};

export const getIconData = async (section?: string): Promise<IIconResponseData | ISection> => {
  const localStorageMobileNo = localStorage.getItem(COMMON_SSO_MOBILE);
  const mobileNo = await decryptLocalStorageMobileNo(localStorageMobileNo || "");
  const response = await createCacheAsync(`${API_PATHS.pimcoreIcons}-${mobileNo}`, iconApiCall);
  if (section && response?.data) {
    const match = response.data.find(
      (item) => item.sectionValue.toLowerCase() === section.toLowerCase()
    );
    return match ?? response;
  }
  return response;
};
